import React from 'react';
import { Navigate } from 'react-router-dom';
import { shouldAllowBookings } from '../../utils/domain';

const BookingGuard = ({ children }) => {
  if (!shouldAllowBookings()) {
    // Redirect to home page if domain is not authorized
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default BookingGuard; 